import { render } from "./WebDesign.vue?vue&type=template&id=e50bd0f4&scoped=true"
import script from "./WebDesign.vue?vue&type=script&lang=js"
export * from "./WebDesign.vue?vue&type=script&lang=js"

import "./WebDesign.vue?vue&type=style&index=0&id=e50bd0f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e50bd0f4"]])

export default __exports__